<p-toast></p-toast>
<div *ngIf="errorMessages.length > 0" class="assignmentGroupSliderErrorMessagePlaceHolder">
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="p-message-wrapper">
        <div>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">{{errorMessageHeaderText}}</span>        
      </div>
      <div>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </div>
    </div>
    </ng-template>
  </p-messages>
</div>

<form [formGroup]="assignmentGroupForm">
  <div class="general-tab">
    <div class="fields-row">
      <div class="field field-required p-field">
      <label for="eQMSScope" class="p-d-block">{{treeSelectPlaceHolderText}}</label>
       <p-treeSelect
      selectionMode="single"
      formControlName="eQMSScope"
      [options]="eQMSScopes"
      [ngClass]="{ 'error-highlight': mandatoryFields['eQMSScope'] }"
      (ngModelChange)="onAssignmentOrScopeChange()"
      [filter]="true"
      [showClear]="true"
    ></p-treeSelect>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-text-input
          label="Name*"
          [ngClass]="{ 'error-highlight': mandatoryFields['name'] }"
          [disabled]="false"
          id="assignmentGroupName"
          formControlName="name"
          [maxlength]="64"
        ></bpt-text-input>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Assignment*"
          [options]="assignments"
          formControlName="assignment"
          id="assignmentId"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['assignment'] }"
          (ngModelChange)="onAssignmentOrScopeChange()"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-text-input
          [highlightAllOnFocus]="true"
          [multiLine]="true"
          id="descriptionId"
          formControlName="description"
          label="Description"
          [autoResize]="true"
        ></bpt-text-input>
      </div>     
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Users*"
          [options]="updatedUsersList"
          id="usersId"
          formControlName="users"
          [multiSelect]="true"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['users'] }"
        >
        </bpt-dropdown>
      </div>  
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-toggle-switch 
        [toggleSwitchLabel]="toggleSwitchLabel"
        formControlName="isActive"
        >
        </bpt-toggle-switch>
      </div>  
    </div>
  </div>
  <div class="button">
    <p-button
    appPreventDoubleClick
    *ngIf=true
      label="Save"
      type="submit"
      id="assignmentGroupSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="saveAssignmentGroupForm()"
    >
    </p-button>    
  </div>
</form>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveAssignmentGroupwithInactiveUsers()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>


